/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Refresh_In_One_Min_ContentInputs */

const en_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items will refresh soon. Please wait a moment.`)
};

const ar_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيتم تحديث المنتجات قريبًا. يُرجى الانتظار قليلًا.`)
};

const de_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Artikel werden gleich aktualisiert. Bitte warte einen Moment.`)
};

const es_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los artículos se actualizarán pronto. Espera un momento.`)
};

const fr_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les articles vont bientôt s’actualiser. Patientez un instant.`)
};

const it_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli articoli si aggiorneranno a breve. Attendi un momento.`)
};

const ja_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まもなく商品が更新されます。少々お待ちください。`)
};

const ko_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`곧 상품이 새로고침됩니다. 잠시만 기다려 주세요.`)
};

const pt_br_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os itens serão atualizados em breve. Aguarde um momento.`)
};

const ru_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Товары скоро обновятся. Подождите немного.`)
};

const th_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สินค้าจะรีเฟรชเร็ว ๆ นี้ กรุณารอสักครู่`)
};

const tr_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürünler yakında yenilenecek. Lütfen biraz bekle.`)
};

const zh_cn_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品就快要刷新了，再等一下！`)
};

const zh_tw_dialog_refresh_in_one_min_content = /** @type {(inputs: Dialog_Refresh_In_One_Min_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品就快要刷新了，再等一下！`)
};

/**
* | output |
* | --- |
* | "Items will refresh soon. Please wait a moment." |
*
* @param {Dialog_Refresh_In_One_Min_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_refresh_in_one_min_content = /** @type {((inputs?: Dialog_Refresh_In_One_Min_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Refresh_In_One_Min_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_refresh_in_one_min_content(inputs)
	if (locale === "ar") return ar_dialog_refresh_in_one_min_content(inputs)
	if (locale === "de") return de_dialog_refresh_in_one_min_content(inputs)
	if (locale === "es") return es_dialog_refresh_in_one_min_content(inputs)
	if (locale === "fr") return fr_dialog_refresh_in_one_min_content(inputs)
	if (locale === "it") return it_dialog_refresh_in_one_min_content(inputs)
	if (locale === "ja") return ja_dialog_refresh_in_one_min_content(inputs)
	if (locale === "ko") return ko_dialog_refresh_in_one_min_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_refresh_in_one_min_content(inputs)
	if (locale === "ru") return ru_dialog_refresh_in_one_min_content(inputs)
	if (locale === "th") return th_dialog_refresh_in_one_min_content(inputs)
	if (locale === "tr") return tr_dialog_refresh_in_one_min_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_refresh_in_one_min_content(inputs)
	return zh_tw_dialog_refresh_in_one_min_content(inputs)
});